import { useMutation, useQueryClient } from '@tanstack/react-query'
import axios from 'axios';
import { useSnackbar } from '../../../components/notifications/use-snackbar';
import { useCompanyId } from '../../../app/agistics-context';
import { OrgQueryKeys } from '../../config';
import { User } from '../../../types';

interface ResetOtpVariables {
    userId: number;
}

export const useResetOtp = () => {
    const companyId = useCompanyId();
    const snackbar = useSnackbar();
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: async (variables: ResetOtpVariables) => {

            const data = {
                userId: variables.userId,
            }

            return axios.post(`${API_BASE}/api/users/reset-otp`, data);
        },
        onSuccess: (_1, variables) => {
            const usersQueryKey = `/organizations/${companyId}${OrgQueryKeys.users}`;

            queryClient.setQueryData<User[]>([usersQueryKey], (old) => {
                if (old) {
                    const newUsers = old.map(oldUser => {
                        if (oldUser.id === variables.userId) {
                            return {
                                ...oldUser,
                                otpSetup: false,
                            }
                        }

                        return oldUser;
                    });

                    return newUsers;
                }
            });

            snackbar('OTP Reset');
        }
    });

    return mutation;
}
